import useUserInfoForm from "./UseUserInfoForm";

import Input from "@usas/ui-web/components/inputs/Input";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import PhoneInput from "@usas/ui-web/components/inputs/InternationalPhoneInput";

const UserInfoForm = ({ userInfoData, childData, isUserUnder16 = false, submitButtonText = 'Continue', secondaryButtonText = 'Back', onSubmitFormCallback,
  onSecondaryButtonClicked }) => {
  const {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    onEmailChanged,
  } = useUserInfoForm(onSubmitFormCallback, userInfoData, childData, isUserUnder16);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          {childData?.firstName
            ? (
              <ReadOnly
                label={'Child First Name'}
                name={'firstName'}
                value={formState.firstName} />
            ) : (
              <Input
                label={'Legal First Name*'}
                name={'firstName'}
                value={formState.firstName}
                error={!!errorState.firstName}
                message={errorState.firstName}
                onChange={(value) => updateFormState('firstName', value)} />
            )
          }
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          {childData // Not needed for dup match so if childData is provided make readonly
            ? (
              <ReadOnly
                label={'Child Preferred Name'}
                name={'preferredName'}
                value={formState.preferredName} />
            ) : (
              <Input
                label={'Preferred Name'}
                name={'preferredName'}
                value={formState.preferredName}
                error={!!errorState.preferredName}
                message={errorState.preferredName}
                onChange={(value) => updateFormState('preferredName', value)} />
            )
          }
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          {childData // Not needed for dup match so if childData is provided make readonly
            ? (
              <ReadOnly
                label={'Child Middle Name'}
                name={'middleName'}
                value={formState.middleName} />
            ) : (
              <Input
                label={'Middle Name'}
                name={'middleName'}
                value={formState.middleName}
                onChange={(value) => updateFormState('middleName', value)} />
            )
          }
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          {childData?.lastName
            ? (
              <ReadOnly
                label={'Child Last Name'}
                name={'lastName'}
                value={formState.lastName} />
            ) : (
              <Input
                label={'Legal Last Name*'}
                name={'lastName'}
                value={formState.lastName}
                error={!!errorState.lastName}
                message={errorState.lastName}
                onChange={(value) => updateFormState('lastName', value)} />
            )
          }
        </div>
        {!isUserUnder16 && (
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label={'Email* '}
              name={'email'}
              value={formState.email}
              error={!!errorState.email}
              message={errorState.email}
              onChange={(value) => onEmailChanged(value)} />
          </div>
        )}
        {!isUserUnder16 && (
          <div className="col-xs-12 col-sm-6 col-md-4">
            <PhoneInput
              label={'Phone Number*'}
              name={'phoneNumber'}
              value={formState.phoneNumber}
              error={!!errorState.phoneNumber}
              message={errorState.phoneNumber}
              onChange={(value) => updateFormState('phoneNumber', value)} />
          </div>
        )}
        <div className="col-xs-12 col-sm-6 col-md-4">
          {childData?.memberId
            ? (
              <ReadOnly
                label={'Child Member Id'}
                name={'memberId'}
                value={formState.memberId} />
            ) : (
              <Input
                label={'Member Id (Use to link to an existing person)'}
                name={'memberId'}
                value={formState.memberId}
                error={!!errorState.memberId}
                message={errorState.memberId}
                onChange={(value) => updateFormState('memberId', value)} />
            )
          }
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit">{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type='button' onClick={() => onSecondaryButtonClicked(formState)}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default UserInfoForm;